import { createSlice } from '@reduxjs/toolkit';
import { OpenAndCloseNotification } from './notification-reducer'
const initialState = {};

const userSlice = createSlice({
    name:'typeCall',
    initialState,
    reducers: {
        saveUser: (state, payload) => {
            return payload.payload
         },
         logoutUser: () => {
            localStorage.clear();
             return {}
         }
    }
})


export const refreshToken = (state, navigate) => (dispatch) => { 
if(state != null) {
        const tokenNotification = {message: "il token sta per scadere", status: state}
        const timerAvviso = 300000 

        let now = Date.now();
        let expireDate = Date.parse(state.scadenzaToken);

        clearTimeout(state.timerToken)
        clearTimeout(state.timerTokenNotification)
        
        const timerTokenNotification = setTimeout(() => dispatch(OpenAndCloseNotification(tokenNotification)), expireDate - ( now + timerAvviso))
        const timerToken = setTimeout(() => { dispatch(logoutUser()); navigate("/") }, expireDate - now)
        let response = {...state, timerTokenNotification, timerToken}

        dispatch(saveUser(response))
    }
}

export const { saveUser, logoutUser } = userSlice.actions;

const { reducer } = userSlice;

export default reducer
